import { SurveyProps } from './Survey.props';

import SurveyView from './Survey.view';

const SurveyContainer = (props: SurveyProps) => {
  return <SurveyView survey={props.location.state} {...props} />;
};

export default SurveyContainer;
